import { Box, BoxProps } from '@mantine/core'

import useStyles from './index.styles'
import { Chart } from '../Chart'
import { Information } from '../Information'
import { Layout } from '../Layout'
import { LocationSelector } from '../LocationSelector'
import { TimeStatus } from '../TimeStatus'

export const Form = ({ styles, classNames, className, ...rest }: BoxProps) => {
  const { classes } = useStyles(undefined, {
    name: 'AirPopulation__Form',
    styles,
    classNames,
  })

  return (
    <Layout
      {...rest}
      classNames={{
        colLeft: classes.colLeft,
        colRight: classes.colRight,
      }}
      colLeft={
        <Box className={classes.info}>
          <Box className={classes.locator}>
            <LocationSelector />
            <TimeStatus />
          </Box>
          <Box className={classes.infoColLeft}>
            <Information />
          </Box>
        </Box>
      }
      colRight={
        <Box className={classes.chart}>
          <Chart />
          <Box className={classes.infoColRight}>
            <Information />
          </Box>
        </Box>
      }
    />
  )
}
